import { toast } from "helpers/Utils";
import { GET_FLOAT_DATA, GET_FLOAT_DATA_BY_ID, GET_FLOAT_DATA_BY_ID_FAILED, GET_FLOAT_DATA_BY_ID_SUCCESS, GET_FLOAT_DATA_FAILED, GET_FLOAT_DATA_SUCCESS, GET_FLOAT_DATA_BY_TRANSACTION_ID, GET_FLOAT_DATA_BY_TRANSACTION_ID_FAILED, GET_FLOAT_DATA_BY_TRANSACTION_ID_SUCCESS, GET_CURRENT_BALANCE, GET_CURRENT_BALANCE_FAILED, GET_CURRENT_BALANCE_SUCCESS, ADD_UPDATE_BALANCE, ADD_UPDATE_BALANCE_SUCCESS, ADD_UPDATE_BALANCE_FAILED } from "./Action";

const initialState = {
  floatData: [],
  floatDataById: [],
  balanceCheck: "",
  message: "",
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FLOAT_DATA:
      return { ...state, loading: true, message: "" };
    case GET_FLOAT_DATA_SUCCESS:
      return { ...state, floatData: action.data, message: action.message, loading: false };
    case GET_FLOAT_DATA_FAILED:
      return { ...state, message: action.message };
    case GET_FLOAT_DATA_BY_ID:
      return { ...state, loading: true, message: "" };
    case GET_FLOAT_DATA_BY_ID_SUCCESS:
      return { ...state, floatDataById: action.data.listTransaction, count: action.data.count, message: action.message, loading: false };
    case GET_FLOAT_DATA_BY_ID_FAILED:
      return { ...state, message: action.message };
    case GET_FLOAT_DATA_BY_TRANSACTION_ID:
      return { ...state, loading: true, message: "" };
    case GET_FLOAT_DATA_BY_TRANSACTION_ID_SUCCESS: {
      const hasTransactions = Array.isArray(action.data?.listTransaction) && action.data.listTransaction.length > 0;
      const responseData = hasTransactions ? action.data.listTransaction : [];
      return { ...state, floatDataById: responseData, count: action.data?.count || 0, loading: false };
    }
    case GET_FLOAT_DATA_BY_TRANSACTION_ID_FAILED:
      return { ...state, message: action.message };
    case GET_CURRENT_BALANCE:
      return { ...state, loading: true, message: "", balanceCheck: null }; 
    case GET_CURRENT_BALANCE_SUCCESS:
      return { ...state, balanceCheck: action.data, message: action.message, loading: false };
    case GET_CURRENT_BALANCE_FAILED:
      return { ...state, message: action.message, balanceCheck: null };
    case ADD_UPDATE_BALANCE:
      return { ...state, loading: true, message: "" };
    case ADD_UPDATE_BALANCE_SUCCESS:
      toast("Amount successfully updated!", "", "success");
      return { ...state, balanceCheck: action.data, message: action.message, loading: false };
    case ADD_UPDATE_BALANCE_FAILED:
      toast("Failed to update amount!", "", "error");
      return { ...state, message: action.message };
    default:
      return state;
  }
};
